<template>
  <product-shop-the-look
    v-if="product?.productSets?.length"
    :product-sets="product.productSets"
    @open-shop-the-look="openShopTheLook($event)"
  />
</template>

<script lang="ts" setup>
const { openShopTheLook, product } = usePdp()
</script>
